import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

const NAVIGATION_STORE = 'navigationStore';

type NavigationState = {
    isNavigating: boolean;
};

type NavigationActions = {
    setIsNavigating: (isNavigating: boolean) => void;
};

const initialState: NavigationState = {
    isNavigating: false,
};

export const useNavigationStore = create<NavigationState & NavigationActions>()(
    devtools(
        persist(
            (set) => ({
                ...initialState,

                setIsNavigating: (isNavigating: boolean) =>
                    set({ ...initialState, isNavigating }, false, 'setIsNavigating'),
            }),
            {
                name: NAVIGATION_STORE,
                version: 1,
            },
        ),
        { name: NAVIGATION_STORE, enabled: true },
    ),
);

if (typeof window !== 'undefined' && window.navigation) {
    window.navigation.addEventListener('navigate', () => {
        useNavigationStore.getState().setIsNavigating(true);
    });

    window.navigation.addEventListener('navigatesuccess', () => {
        useNavigationStore.getState().setIsNavigating(false);
    });

    window.navigation.addEventListener('navigateerror', () => {
        useNavigationStore.getState().setIsNavigating(false);
    });
}
